exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#_2bv72mmzdg7gKyUmefeVrD{position:fixed;top:0;left:0;z-index:5;width:100%;height:100%}._2gSRcxtvNU7pEPBzY7zG12{position:absolute;top:0;left:0;border:none;width:100%;height:100%}", ""]);

// exports
exports.locals = {
	"root": "_2bv72mmzdg7gKyUmefeVrD",
	"rootLayer": "_2gSRcxtvNU7pEPBzY7zG12"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?module&-autoprefixer!./~/postcss-loader!./src/components/App/Layers/index.css
// module id = 476
// module chunks = 1